import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../../api/mutations'
import {invalidateSettingsQuery} from '../../../../common/providers/ApiInterface'
import {ErrorResponse} from '../../../../common/types'
import {notifyIfErrorMessage} from '../../../../common/utils/errorHandling'
import {DefaultAssetOperationTime} from '../../../types'

export const useAddDefaultAssetOperationTime = () => {
  const {t} = useTranslation()
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<
    DefaultAssetOperationTime,
    AxiosError<ErrorResponse>,
    Parameters<typeof mutations.addDefaultAssetOperationTime>[0]
  >({
    mutationFn: mutations.addDefaultAssetOperationTime,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: () => {
      notify('success', t('success.addStandardOperationTime'))
    },
    onSettled: () => {
      invalidateSettingsQuery('defaultAssetsOperationTimes')
    }
  })
}
